var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512.45,
    height: 433.067,
    viewBox: "0 0 512.45 433.067",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh_1_",
    "data-name": "refresh (1)",
    transform: "translate(0 -39.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M152.083,286.8a12.6,12.6,0,0,0-9.5-20.888H110.19c-.211-3.2-.329-6.435-.329-9.692,0-80.706,65.658-146.364,146.363-146.364a145.829,145.829,0,0,1,100.3,39.877L402.2,96.3A216.53,216.53,0,0,0,39.691,256.224c0,3.243.081,6.473.222,9.692H12.629a12.6,12.6,0,0,0-9.5,20.888l61.549,70.6L77.6,372.233l46.416-53.242Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M509.321,245.614l-45.907-52.658-28.57-32.771-40.791,46.789-33.686,38.64a12.6,12.6,0,0,0,9.5,20.888h32.354c-5.293,75.928-68.748,136.086-146,136.086a145.624,145.624,0,0,1-89.586-30.7L120.96,425.324A216.542,216.542,0,0,0,472.515,266.5h27.306a12.606,12.606,0,0,0,9.5-20.889Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.3ea1e6c0552d8d4319d08097da1e8605.svg";
export { ForwardRef as ReactComponent };